/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FilterDataDTO } from './filterDataDTO';
import { FilterDTO } from './filterDTO';


export interface FilterConfigDefaultsDTO { 
    filtersConfiguration?: Array<FilterDTO>;
    filters?: { [key: string]: Array<FilterDataDTO>; };
}

